<template>
  <div>
    <el-table :data="projects">
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column
        prop="borrowCoinType"
        label="借币种类型"
      ></el-table-column>
      <el-table-column prop="defaultRate" label="违约利率"></el-table-column>
      <el-table-column prop="overdueRate" label="逾期利率"></el-table-column>
      <el-table-column prop="numberDays" label="周期"></el-table-column>
      <el-table-column label="利率" prop="yearRate"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip content="修改">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="删除">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-delete"
              @click="removeList(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Detail from '../detail';

export default {
  name: 'cycleList',
  computed: {
    ...mapState('cycle', ['projects'])
  },
  components: {
    Detail
  },
  methods: {
    ...mapActions('cycle', ['remove', 'getList']),
    ...mapMutations('cycle', ['setEditingProject']),
    edit(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    removeList(row) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove({
            borrowCoinType: row.borrowCoinType,
            numberDays: row.numberDays
          }).then(() => {
            this.$message.success('删除成功！');
            this.getList();
          });
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
